import React from 'react';
import {
  Notification as WixNotification,
  NotificationTheme,
} from '@wix/design-system';

export const NOTIFICATION_TIMEOUT = 4000;

interface Props {
  dataHook?: string;
  theme?: NotificationTheme;
  show?: boolean;
  onClose: any;
  onReady: any;
  zIndex?: number;
}

// NOTE: we should use inheritance instead of decoration because we want to save interface of origin
// <Notifications/> component and keep using <Notification.TextLabel/> and <Notification.CloseButton/> out of the box
export class Notification extends React.Component<Props> {
  public static TextLabel = WixNotification.TextLabel;
  public static CloseButton = WixNotification.CloseButton;

  public componentDidMount() {
    this.props.onReady();

    setTimeout(() => {
      this.props.onClose();
    }, NOTIFICATION_TIMEOUT);
  }

  public render() {
    return (
      <div>
        <WixNotification
          autoHideTimeout={NOTIFICATION_TIMEOUT}
          {...this.props}
          type="local"
        />
      </div>
    );
  }
}
